export default {
    researchActivities:
        [
            {
                label: '—',
                exportLabel: '',
                value: 0
            },
            {
                label: '1. Underbyggende Forskning',
                value: 1
            },
            {
                label: '2. Årsaksforhold',
                value: 2
            },
            {
                label: '3. Forebygging',
                value: 3
            },
            {
                label: '4. Påvising og diagnose',
                value: 4
            },
            {
                label: '5. Utvikling av behandlinger',
                value: 5
            },
            {
                label: '6. Evaluering av behandlinger',
                value: 6
            },
            {
                label: '7. Håndtering av sykdommer og tilstander',
                value: 7
            },
            {
                label: '8. Helse- og sosialtjenesteforskning',
                value: 8
            },
        ],
    healthCategories: [
        {
            label: '—',
            value: 0
        },
        {
            label: '1. Blod',
            value: 1
        },
        {
            label: '2. Kreft',
            value: 2
        },
        {
            label: '3. Hjerte og kar',
            value: 3
        },
        {
            label: '4. Medfødte lidelser',
            value: 4
        },
        {
            label: '5. Øre',
            value: 5
        },
        {
            label: '6. Øye',
            value: 6
        },
        {
            label: '7. Infeksjon',
            value: 7
        },
        {
            label: '8. Betennelse og immunsystem',
            value: 8
        },
        {
            label: '9. Skader og ulykker',
            value: 9
        },
        {
            label: '10. Mental helse',
            value: 10
        },
        {
            label: '11. Stoffskifte og hormoner',
            value: 11
        },
        {
            label: '12. Muskel og skjelett',
            value: 12
        },
        {
            label: '13. Hjernen og nervesystemet',
            value: 13
        },
        {
            label: '14. Munnhule, mage-tarm',
            value: 14
        },
        {
            label: '15. Nyrer, urinveier og kjønnsorgan',
            value: 15
        },
        {
            label: '16. Forplantning og fødsel',
            value: 16
        },
        {
            label: '17. Lunger og luftveier',
            value: 17
        },
        {
            label: '18. Hud',
            value: 18
        },
        {
            label: '19. Hjerneslag',
            value: 19
        },
        {
            label: '20. Generell helserelevans',
            value: 20
        },
        {
            label: '21. Indre',
            value: 21
        }
    ],
    spreadsheet: {
        RESEARCH_ACTIVITY_1: 'Forskningsaktivitet 1 (kode)',
        RESEARCH_ACTIVITY_1_PERCENTAGE: 'Forskningsaktivitet 1 (andel)',
        RESEARCH_ACTIVITY_1_DESCRIPTION: 'Forskningsaktivitet 1',

        RESEARCH_ACTIVITY_2: 'Forskningsaktivitet 2 (kode)',
        RESEARCH_ACTIVITY_2_PERCENTAGE: 'Forskningsaktivitet 2 (andel)',
        RESEARCH_ACTIVITY_2_DESCRIPTION: 'Forskningsaktivitet 2',

        HEALTH_CATEGORY_1: 'Helsekategori 1 (kode)',
        HEALTH_CATEGORY_1_PERCENTAGE: 'Helsekategori 1 (andel)',
        HEALTH_CATEGORY_1_DESCRIPTION: 'Helsekategori 1',

        HEALTH_CATEGORY_2: 'Helsekategori 2 (kode)',
        HEALTH_CATEGORY_2_PERCENTAGE: 'Helsekategori 2 (andel)',
        HEALTH_CATEGORY_2_DESCRIPTION: 'Helsekategori 2',

        HEALTH_CATEGORY_3: 'Helsekategori 3 (kode)',
        HEALTH_CATEGORY_3_PERCENTAGE: 'Helsekategori 3 (andel)',
        HEALTH_CATEGORY_3_DESCRIPTION: 'Helsekategori 3',

        HEALTH_CATEGORY_4: 'Helsekategori 4 (kode)',
        HEALTH_CATEGORY_4_PERCENTAGE: 'Helsekategori 4 (andel)',
        HEALTH_CATEGORY_4_DESCRIPTION: 'Helsekategori 4',

        HEALTH_CATEGORY_5: 'Helsekategori 5 (kode)',
        HEALTH_CATEGORY_5_PERCENTAGE: 'Helsekategori 5 (andel)',
        HEALTH_CATEGORY_5_DESCRIPTION: 'Helsekategori 5',
    }
}


// WEBPACK FOOTER //
// ./src/HrcsEditor/config.js